<template>
    <div class="spinner">
      <div class="rect1" :style="'background-color:'+color"></div>
      <div class="rect2" :style="'background-color:'+color"></div>
      <div class="rect3" :style="'background-color:'+color"></div>
      <div class="rect4" :style="'background-color:'+color"></div>
      <div class="rect5" :style="'background-color:'+color"></div>
<!--      <div class="rect1"></div>-->
<!--      <div class="rect2"></div>-->
<!--      <div class="rect3"></div>-->
<!--      <div class="rect4"></div>-->
<!--      <div class="rect5"></div>-->
    </div>
</template>

<script>
    export default {
        name: 'Loader1',
        props: ['color']
    }
</script>

<style scoped>
  .spinner {
    /*margin: 100px auto;*/
    width: 50px;
    height: 40px;
    text-align: center;
    font-size: 10px;
    display: inline-block;
  }

  .spinner > div {
    background-color: #333;
    /*background-color: white;*/
    height: 100%;
    width: 6px;
    display: inline-block;

    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
  }

  .spinner .rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
  }

  .spinner .rect3 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
  }

  .spinner .rect4 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
  }

  .spinner .rect5 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
  }

  @-webkit-keyframes sk-stretchdelay {
    0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
    20% { -webkit-transform: scaleY(1.0) }
  }

  @keyframes sk-stretchdelay {
    0%, 40%, 100% {
      transform: scaleY(0.4);
      -webkit-transform: scaleY(0.4);
    }  20% {
         transform: scaleY(1.0);
         -webkit-transform: scaleY(1.0);
       }
  }
</style>



// WEBPACK FOOTER //
// Loader1.vue?72039b4b